<template>
  <div class="whiteBg">
    <div class="container row3">
      <div class="text">
        <h2 class="font-weight-bold">
          내 가게, 내 제품이 <span class="mobile" /> 어떤 키워드로 노출중인지<br />
          직접 보여드립니다.
        </h2>
        <p class="font-weight-light">
          이용한 블로거가 작성한 리뷰가 실제 검색결과에<br />
          노출중인지 확인할 수 있는 마케팅 보고서를 비롯해<br />
          이용/배송 관리, 한줄평 등 통합된 솔루션을 제공합니다.<br />
        </p>
      </div>
      <img :src="image" class="row-image mx-2" />
    </div>
  </div>
</template>

<script>
import userMixin from '@/components/shared/userMixin';

export default {
  name: 'Row4',
  mixins: [userMixin],
  data() {
    return {
      image:
        window.innerWidth > 960
          ? require('@/assets/img/landing/ceo-landing/report.png')
          : require('@/assets/img/landing/ceo-landing/report-mobile.png'),
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.image =
        window.innerWidth > 960
          ? require('@/assets/img/landing/ceo-landing/report.png')
          : require('@/assets/img/landing/ceo-landing/report-mobile.png');
    });
  },
};
</script>

<style scoped lang="scss">
.row3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 72px 0;
  @media (max-width: 960px) {
    padding: 80px 0px 56px;
    overflow: hidden;
  }
}
.row3 .row-image {
  width: 646px;
  margin: 12px 0 0 0;
  @media (max-width: 960px) {
    max-width: 400px;
    margin: 16px auto;
    width: 100%;
    text-align: center;
  }
}
.text {
  .eyebrow {
    color: #757575;
    margin-bottom: 4px;
    margin-left: 1px;
    font-size: 14px;
  }
  h2 {
    margin-bottom: 12px;
    color: #212121;
  }
  p {
    color: #484848;
    line-height: 1.8;
  }
  @media (max-width: 960px) {
    // padding-top: 0;
    // margin-bottom: auto;
    .eyebrow {
      margin-bottom: 6px;
      font-size: 13px;
    }
    h2 {
      margin-bottom: 12px;
    }
    p {
      color: #484848;
      line-height: 1.94;
    }
  }
}

.rank-button {
  background: #ffffff;
  border: 2px solid #bd1328;
  border-radius: 16px;
  color: #bd1328;
  font-size: 14px;
}

.whiteBg {
  background-color: #fbfbfb;
}
</style>
